import ResetPass from "./ResetPass";

export default ResetPass;
